import { motion } from "framer-motion";

const reveal = {
  hidden: { opacity: 0, y: 24 },
  visible: (i = 0) => ({
    opacity: 1,
    y: 0,
    transition: {
      delay: 0.05 + i * 0.04,
      duration: 0.9,
      ease: [0.16, 1, 0.3, 1],
    },
  }),
};

export const Reveal = ({ children, delay = 0, className = "", as = "div" }) => {
  const MotionTag = motion[as] || motion.div;
  return (
    <MotionTag
      className={className}
      initial="hidden"
      whileInView="visible"
      viewport={{ once: true, amount: 0.25 }}
      variants={{
        hidden: { opacity: 0, y: 30 },
        visible: {
          opacity: 1,
          y: 0,
          transition: {
            delay,
            duration: 1.1,
            ease: [0.16, 1, 0.3, 1],
          },
        },
      }}
    >
      {children}
    </MotionTag>
  );
};

export const RevealText = ({ text, className = "", stagger = 0.02, delay = 0 }) => {
  const words = text.split(" ");
  return (
    <motion.span
      className={className}
      initial="hidden"
      whileInView="visible"
      viewport={{ once: true, amount: 0.3 }}
    >
      {words.map((w, i) => (
        <span key={i} style={{ display: "inline-block", overflow: "hidden" }}>
          <motion.span
            style={{ display: "inline-block" }}
            variants={{
              hidden: { y: "110%" },
              visible: {
                y: 0,
                transition: {
                  delay: delay + i * stagger,
                  duration: 1.05,
                  ease: [0.16, 1, 0.3, 1],
                },
              },
            }}
          >
            {w}
            {i < words.length - 1 && "\u00A0"}
          </motion.span>
        </span>
      ))}
    </motion.span>
  );
};

export { reveal };
